import Swal from "sweetalert2";

const useAlertModal = () => {

    const showAlert = ({title, message, iconType = "info", redirectTo = "", options = {}}) => {
        const defaultOptions = {
            title,
            text: message,
            icon: iconType,
            confirmButtonText: "OK",
            ...options, // Permite sobrescrever as configurações padrão
        };

        Swal.fire(defaultOptions).then(() => {
            if (redirectTo !== "") {
                window.location.href = redirectTo;
            }
        });
    };

    return {showAlert};
};

export default useAlertModal;
